export const CODE_LANGUAGES = Object.freeze({
  json: "json",
  css: "css"
});
